export default __webpack_public_path__ + "static/media/SEN-TEM-HUM.fbec3e59.png";